var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_corporate,
          icon: 'fa fa-users text-dtac',
          path: '/portal/corporate'
        }}}),(_vm.isDtacAdminMenu || _vm.isReadOnly)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_package,
          path: '/portal/package',
          icon: 'ni ni-ungroup text-dtac'
        }}}):_vm._e(),(_vm.isDtacAdminMenu || _vm.isReadOnly)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_pilot_number,
          path: '/portal/pilotnumber',
          icon: 'fa fa-phone-square text-dtac'
        }}}):_vm._e(),(_vm.isDtacAdminMenu || _vm.isReadOnly)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_agent_number,
          path: '/portal/number',
          icon: 'fa fa-mobile text-dtac'
        }}}):_vm._e(),(_vm.isDtacAdminMenu || _vm.isReadOnly)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_user,
          path: '/portal/users',
          icon: 'fa fa-user text-dtac'
        }}}):_vm._e(),(_vm.isCorporateAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_mlhg,
          path: '/portal/mlhg',
          icon: 'ni ni-ungroup text-dtac'
        }}}):_vm._e(),(_vm.isCorporateAdminMenu)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_pilot_number,
          path: '/portal/pilotnumber',
          icon: 'fa fa-phone-square text-dtac'
        }}}):_vm._e(),(_vm.isCorporateAdminMenu)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_agent_number,
          path: '/portal/number',
          icon: 'fa fa-mobile text-dtac'
        }}}):_vm._e(),(_vm.isDtacAdminMenu || _vm.isReadOnly)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_capacity,
          path: '/portal/capacity',
          icon: 'fa fa-server text-info'
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_cdr,
          path: '/portal/record',
          icon: 'ni ni-chart-pie-35 text-info'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_report,
          path: '/portal/report',
          icon: 'ni ni-chart-pie-35 text-info'
        }}}),(_vm.isMigrationUserMenu)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_easmigration,
          path: '/portal/easmigration',
          icon: 'fa fa-exchange-alt text-info'
        }}}):_vm._e(),(_vm.isMigrationUserMenu)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.menu_voicemaillog,
          path: '/portal/voicemail/backuplog',
          icon: 'fa fa-envelope text-info'
        }}}):_vm._e()]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }